import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    outerContainer: {
      paddingTop: "1rem",
      paddingLeft: "1rem",
      paddingRight: "1rem",
      paddingBottom: "1rem",
    },
    breadcrumbsContainer: {
      position: "sticky",
      zIndex: "1000",
      top: "0",
      marginTop: "-16px",
      marginLeft: "-25px",
      marginRight: "-25px",
      paddingLeft: "16px",
    },
    breadcrumbsContainerForUsers: {
      position: "sticky",
      zIndex: "1000",
      top: "75px",
      marginTop: "-16px",
      marginLeft: "-15px",
      marginRight: "-25px",
    },
    breadcrumbsContainerForAdmins: {
      position: "sticky",
      zIndex: "1000",
      top: "0px",
      marginTop: "-28px",
      marginLeft: "-15px",
      marginRight: "-25px",
    },
    breadcrumbItem: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      color: theme.palette.text.primary,
      padding: "4px 0px",
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: "5px",
      fontSize: "18px",
    },
    breadcrumpLabel: {
      fontSize: "14px",
    },
    addAppointmentContainer: {
      marginTop: "8px",
      marginBottom: "1rem",
    },
    addAppointmentLabelContainer: {
      marginBottom: "10px",
    },
    addAppointmentLabel: {
      fontSize: "1.6rem",
    },
    addAppointmentFormContainer: {
      paddingTop: "2rem",
      paddingBottom: "2rem",
      paddingLeft: "1rem",
      paddingRight: "1.5rem",
    },
    switchContainer: {
      display: "flex",
      alignItems: "center",
      marginLeft: "0.1rem",
    },
    footerContainer: {
      zIndex: "1000",
      position: "fixed",
      bottom: "0",
      width: "100%",
      left: "0",
    },
    footerContainerInner: {
      height: "60px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: "1.5rem",
    },
    saveButton: {
      marginLeft: "1rem",
    },
    addOption: {
      width: "100%",
      textAlign: "center",
      color: "#0288d1",
    },
    optionsContainer: {
      display: "flex",
      alignItems: "center",
    },
    optionAvatar: {
      marginRight: "12px",
    },
    optionAvatarImage: {
      height: "35px",
      width: "35px",
      borderRadius: "100%",
      marginTop: "5px",
      border: "1px solid rgba(0, 0, 0, 0.2)",
    },
    optionNameContainer: {
      marginRight: "5px",
    },
    root: {
      overflow: "hidden",
    },
    calendarCtr: {
      backgroundColor: "#1e7bbb",
    },
    calendar: {
      flexWrap: "nowrap",
      justifyContent: "",
      width: "100%",
      margin: "auto",
      marginTop: "-4rem",
      backgroundColor: "#FFF",
      paddingTop: "4rem",
      borderRadius: ".5rem",
      color: "#8898aa",
    },
    ctrButton: {
      margin: ".2rem",
      color: "#8898aa",
      backgroundColor: "#FFF",
      padding: ".2rem",
      borderRadius: ".5rem",
    },
    currentDate: {
      color: "#FFF",
    },
    appointmentModal: {
      padding: "20px 24px",
    },
    dialogPaper: {
      borderRadius: 16,
      overflow: "hidden",
    },
    dialogHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      padding: "16px 20px",
      backgroundColor: "#f8fafc",
      borderBottom: "1px solid #eef0f3",
    },
    dialogHeaderLeft: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      minWidth: 0,
    },
    dialogHeaderIcon: {
      width: 44,
      height: 44,
      borderRadius: 12,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(17, 98, 254, 0.1)",
      color: "#1162FE",
    },
    dialogTitleText: {
      fontSize: "1.1rem",
      fontWeight: 700,
      color: "#1f2937",
      lineHeight: 1.2,
    },
    dialogDate: {
      fontSize: "0.82rem",
      color: "#6b7280",
    },
    deleteBtn: {
      minWidth: 40,
      width: 40,
      height: 40,
      borderRadius: 10,
      padding: 0,
      color: "#e53935",
    },
    dialogActionsBar: {
      padding: "12px 20px 18px",
    },
    cancelBtn: {
      textTransform: "none",
      fontWeight: 600,
      color: "#6b7280",
    },
    saveBtn: {
      textTransform: "none",
      fontWeight: 600,
      borderRadius: 10,
      padding: "6px 24px",
    },

    appointmentTab: {
      padding: "5px",
      fontSize: "12px",
      width: "100%",
      whiteSpace: "nowrap",
      borderRadius: "2px",
      color: "#FFF",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0 2px",
    },

    calenderOptions: {
      textAlign: "end",
    },
    modalTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
  };
});
